module.exports = __webpack_public_path__ + "static/media/snow-blowing.e2785fa7.svg";